var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.rule.resetParts)+" "+_vm._s(_vm.rule.beforeResetMessage)+" ")]),_c('span',{staticClass:"font-bold text-primary-700"},[_vm._v("reset ")]),_c('span',[_vm._v(_vm._s(_vm.rule.afterResetMessage)+".")])])}
var staticRenderFns = []

export { render, staticRenderFns }